import { Injectable } from '@angular/core';

import { ConfigParserService } from './config-parser.service';

export interface AuthStateConfig {
    authTicketExpiryIntervalInMinutes: number;
    checkAuthStateEnabled: boolean;
    checkAuthStateEndpoint: string;
    checkAuthStateIntervalInSeconds: number;
    reauthenticationForAccessTokenPermanentErrorIntervalInMinutes: number;
}

@Injectable({
    providedIn: 'root'
})
export class AuthStateConfigService {
    public readonly config: AuthStateConfig;

    constructor(configParserService: ConfigParserService) {
        // Initialize to default values if there was failure to read user context from page response
        this.config = configParserService.parse<AuthStateConfig>('authStateConfig') || {
            authTicketExpiryIntervalInMinutes: 0,
            checkAuthStateEnabled: false,
            checkAuthStateEndpoint: null,
            checkAuthStateIntervalInSeconds: 0,
            reauthenticationForAccessTokenPermanentErrorIntervalInMinutes: 0
        };
    }
}
